import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { EntityForm } from '../components/common/EntityForm';
import { useEntityMutation } from '../hooks/useEntityMutation';
import { useToast } from '../components/common/Toast';
import { getEntityConfig } from '../lib/entity-config';

export function EntityCreatePage() {
  const { entityName } = useParams<{ entityName: string }>();
  const navigate = useNavigate();
  const config = getEntityConfig(entityName ?? '');
  const { createEntity, isSubmitting } = useEntityMutation();
  const { showToast } = useToast();

  if (!config) return <div className="text-red-500">Unknown entity: {entityName}</div>;

  async function handleSubmit(values: Record<string, any>) {
    try {
      const id = await createEntity(entityName!, values);
      if (!id || typeof id !== 'string') {
        showToast('Create failed: no ID returned from server', 'error');
        console.warn('createEntity returned invalid id:', id);
        return;
      }
      showToast(`${config!.displayName} created successfully`);
      navigate(`/${entityName}/${id}`, { replace: true });
    } catch (err: any) {
      showToast(err.message || 'An unexpected error occurred', 'error');
    }
  }

  return (
    <EntityForm
      entityName={entityName!}
      displayName={config.displayName}
      fields={config.formFields}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
    />
  );
}
